import React, { useState, useEffect } from 'react';
import './CookieConsent.css';

const GA_ID = 'G-W3RS2GXEHK';

function loadGoogleAnalytics() {
  if (window.gaLoaded) return;
  window.gaLoaded = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID);
}

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (consent === 'accepted') {
      loadGoogleAnalytics();
    } else if (!consent) {
      setVisible(true);
    }

    const handleReset = () => {
      localStorage.removeItem('cookie_consent');
      window.gaLoaded = false;
      setVisible(true);
    };
    window.addEventListener('showCookieBanner', handleReset);
    return () => window.removeEventListener('showCookieBanner', handleReset);
  }, []);

  function accept() {
    localStorage.setItem('cookie_consent', 'accepted');
    loadGoogleAnalytics();
    setVisible(false);
  }

  function decline() {
    localStorage.setItem('cookie_consent', 'declined');
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div className="cookie-consent">
      <div className="cookie-consent-content">
        <p className="cookie-consent-text">
          Wir verwenden Google Analytics, um unsere Website zu verbessern. Mit Klick auf „Akzeptieren" stimmen Sie der Verwendung zu. Mehr dazu in unserer{' '}
          <a href="/datenschutz" className="cookie-consent-link">Datenschutzerklärung</a>.
        </p>
        <div className="cookie-consent-buttons">
          <button className="cookie-btn cookie-btn-decline" onClick={decline}>Ablehnen</button>
          <button className="cookie-btn cookie-btn-accept" onClick={accept}>Akzeptieren</button>
        </div>
      </div>
    </div>
  );
}
